<template>
  <div class="backdrop" v-if="popupAlerts">
    <div class="popup-box">
      {{ popupAlerts.message }}
      <b-row class="justify-content-center mt-4">
        <b-button
          variant="primary"
          v-if="popupAlerts.cancelButton"
          @click="closePopup()"
        >
          {{ popupAlerts.cancelButton }}
        </b-button>
        <b-button
          variant="primary"
          v-if="popupAlerts.confirmButton"
          @click="confirmAlert()"
        >
          {{ popupAlerts.confirmButton }}
        </b-button>
      </b-row>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  computed: {
    ...mapGetters(["popupAlerts", "isAlertConfirmed"])
  },
  methods: {
    closePopup() {
      this.$store.commit("CLEAR_POPUP_ALERT");
    },
    confirmAlert() {
      this.$store.commit("ALERT_CONFIRM");
    }
  },
  watch: {
    isAlertConfirmed() {
      this.closePopup();
    }
  }
};
</script>

<style scoped>
.backdrop {
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.51);
  z-index: 2000;
  transition: all 0.3s;
}

.popup-box {
  min-width: 300px;
  max-width: 450px;
  min-height: 100px;
  background: white;
  border: 1px solid;
  border-radius: 20px;
  padding: 25px;
  position: fixed;
  top: 35%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 20px;
}

button {
  margin: 0 10px;
}
</style>
